import { render, staticRenderFns } from "./NewSubscriptionPacks.vue?vue&type=template&id=07c851f5&scoped=true&"
import script from "./NewSubscriptionPacks.vue?vue&type=script&lang=js&"
export * from "./NewSubscriptionPacks.vue?vue&type=script&lang=js&"
import style0 from "./NewSubscriptionPacks.vue?vue&type=style&index=0&id=07c851f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c851f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c851f5')) {
      api.createRecord('07c851f5', component.options)
    } else {
      api.reload('07c851f5', component.options)
    }
    module.hot.accept("./NewSubscriptionPacks.vue?vue&type=template&id=07c851f5&scoped=true&", function () {
      api.rerender('07c851f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/NewSubscriptionPacks.vue"
export default component.exports